import React from 'react';
import { FlashBanner } from './components/FlashBanner';
import { HeroSection } from './components/HeroSection';
import { HeadlineSection } from './components/HeadlineSection';
import { EstoEsParaVosSection } from './components/EstoEsParaVosSection';
import { QueVasALograrSection } from './components/QueVasALograrSection';
import { MetodoAdnCampeonSection } from './components/MetodoAdnCampeonSection';
import { QueVasAEncontrarSection } from './components/QueVasAEncontrarSection';
import { CincoRegalosSection } from './components/CincoRegalosSection';
import { PrecioFinalSection } from './components/PrecioFinalSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FaqSection } from './components/FaqSection';
import { AccesoInmediatoSection } from './components/AccesoInmediatoSection';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <FlashBanner data-id="element-1" />

      {/* Spacer to offset fixed banner */}
      <div className="h-40" data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <HeadlineSection data-id="element-5" />
        <EstoEsParaVosSection data-id="element-6" />
        <QueVasALograrSection data-id="element-7" />
        <MetodoAdnCampeonSection data-id="element-8" />
        <QueVasAEncontrarSection data-id="element-9" />
        <CincoRegalosSection data-id="element-10" />
        <PrecioFinalSection data-id="element-11" />
        <ReviewsSection data-id="element-12" />
        <FaqSection data-id="element-13" />
        <AccesoInmediatoSection data-id="element-14" />
      </main>
    </div>;
}